import React from "react";
import { LayoutPageChromeContext, type LayoutPageChromeContextValue } from "./LayoutPageChromeContext";

export function LayoutPageChromeProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: LayoutPageChromeContextValue;
}) {
  return <LayoutPageChromeContext.Provider value={value}>{children}</LayoutPageChromeContext.Provider>;
}
